import { MenuItem, Restaurant } from '@app/types';
import { useMemo, useRef } from 'react';

export function useEnrichedRestaurant(restaurant: Restaurant | undefined, dateNow: Date | null) {
  const alreadyEnriched = useRef(false);

  return useMemo(() => {
    if (!restaurant || !dateNow || alreadyEnriched.current) return restaurant;

    alreadyEnriched.current = true;
    return enrichRestaurantData(restaurant, dateNow);
  }, [restaurant, dateNow]);
}

function enrichRestaurantData(restaurant: Restaurant, dateNow: Date) {
  if (isNotEligibleToEnrich()) return restaurant;

  restaurant?.menus.forEach((menu) => {
    if (gift()?.menusIds.includes(menu.id)) menu.itens.forEach(injectGiftName);
  });

  return restaurant;

  function injectGiftName(item: MenuItem) {
    let giftText = (gift()?.name ?? '').trim();
    giftText = giftText.startsWith('+') ? giftText : `+ ${giftText}`;

    item.nome = `${item.nome} ${giftText}`;
  }

  function isNotEligibleToEnrich() {
    return Boolean(!restaurant || !gift() || !todayHasGift());

    function todayHasGift() {
      return gift()?.daysOfWeek.includes(dateNow.getDay()) ?? false;
    }
  }

  function gift() {
    return restaurant?.Configuracoes?.brinde;
  }
}
